import { render, staticRenderFns } from "./ProjectViewSidebarAttachmentsCard.vue?vue&type=template&id=2684562a&scoped=true"
import script from "./ProjectViewSidebarAttachmentsCard.vue?vue&type=script&lang=ts"
export * from "./ProjectViewSidebarAttachmentsCard.vue?vue&type=script&lang=ts"
import style0 from "./ProjectViewSidebarAttachmentsCard.vue?vue&type=style&index=0&id=2684562a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2684562a",
  null
  
)

export default component.exports